module.exports = __webpack_public_path__ + "static/media/arrow-circle-right.0f9f12ee.svg";